import React from 'react'
import { SearchField } from 'storfox-query-builder'
import { prop } from 'ramda'
import PropTypes from 'prop-types'

import * as API from '~/constants/api'

const getOptionValue = item => {
  if (item) {
    const guid = prop('guid', item)
    const name = prop('companyName', item)

    return { guid, name }
  }

  return null
}

function SupplierSearchField ({ onChange, ...props }) {
  return (
    <SearchField
      label="Supplier"
      api={API.SUPPLIER_LIST}
      primaryKey="guid"
      getOptionValue={getOptionValue}
      {...props}
      onValueChange={(value) => {
        onChange(null, value)
      }}
    />
  )
}

SupplierSearchField.propTypes = {
  onChange: PropTypes.func.isRequired
}

export default SupplierSearchField
